// getting role from type key from Login and get User info API
export const Roles = {
  FLEET_ROLE: 'fleet',
  FLEET_MANAGER_ROLE: 'fleet_manager',
  ZONAL_FLEET_MANAGER_ROLE: 'zonal_fleet_manager',
  HEAD_OFFICE_BAADSHAH_ROLE: 'head_office_baadshah',
  PROJECT_MANAGER_ROLE: 'project_manager',
}